import { Text } from '@thefarmersfront/kitchen';

import { BellIcon } from '~/components/common/Icon';

import { SMART_SEARCH_PHONE_NUMBER } from '~/constants';

import styles from './SmartSearchContactBanner.module.scss';

const SmartSearchContactBanner = () => {
  return (
    <div className={styles['contact-banner']}>
      <div className={styles['banner']}>
        <div className={styles['banner-left']}>
          <BellIcon size={24} />
          <Text size="medium" color="secondary">
            해결이 어려우시면 문의해 주세요.
          </Text>
        </div>
        <Text className={styles['phone']} size="xlarge" weight="semi-bold">
          {SMART_SEARCH_PHONE_NUMBER}
        </Text>
      </div>
    </div>
  );
};

export default SmartSearchContactBanner;
